var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79012",
    "data-name": "Group 79012",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146323",
    "data-name": "Rectangle 146323",
    width: 44,
    height: 44,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements",
    transform: "translate(8.685 8.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79007",
    "data-name": "Group 79007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62031",
    "data-name": "Path 62031",
    d: "M24.966,6.658H1.664A1.666,1.666,0,0,1,0,4.993V1.664A1.666,1.666,0,0,1,1.664,0h23.3a1.666,1.666,0,0,1,1.664,1.664V4.993A1.666,1.666,0,0,1,24.966,6.658ZM1.664,1.11a.555.555,0,0,0-.555.555V4.993a.555.555,0,0,0,.555.555h23.3a.555.555,0,0,0,.555-.555V1.664a.555.555,0,0,0-.555-.555Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153544",
    "data-name": "Rectangle 153544",
    width: 26,
    height: 17,
    rx: 2,
    transform: "translate(0.315 10.315)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/Body.38fae1e305c8fcdef62b77bb9f35bc05.svg";
export { ForwardRef as ReactComponent };